import React, { useState } from "react";
import "./modal-perfils-styles.css";
import { FormattedMessage, injectIntl } from "react-intl";
import { compose } from "redux";
import { Modal } from "@material-ui/core";
import SdsButton from "../../containers/SdsButton";
import classNames from "classnames";

const ModalPerfils = ({ modalOpen, perfils, userActive, alterarPerfil, intl }) => {
    const [perfilSelecionado, setPerfilSelecionado] = useState(userActive.id);

    const callbackContinuar = () => {
        alterarPerfil(perfilSelecionado);
    }

    return (
        <Modal open={modalOpen}>
            <div className="modal-perfils">
                <h2 className="title">
                    <FormattedMessage id="LABELS.COMMONS.PERFIL_ACESSO" />
                </h2>
                <div className="content">
                    <div className="sds-select-wrap" style={{ width: '100%' }}>
                        <select
                            name="perfil"
                            label="Selecione o perfil"
                            aria-label="Selecione o perfil"
                            className={classNames("sds-select sds-input select-perfil")}
                            defaultValue={perfilSelecionado}
                            onChange={(e) => setPerfilSelecionado(e.target.value)}
                        >
                            {perfils.map(perfil => (
                                <option
                                    key={perfil.id}
                                    value={perfil.id}
                                >
                                    {perfil.identificacao} - {perfil.nome}
                                </option>
                            ))}
                        </select>
                        <i className="material-icons sds-select__icon" aria-hidden="true">arrow_drop_down</i>
                    </div>
                    <div className="info">
                        <p>
                        {intl.formatMessage({id: "LABELS.MESSAGES.COMMONS.MODAL_PERFIL_ACESSO"})}
                            <br/>
                            {intl.formatMessage({id: "LABELS.MESSAGES.COMMONS.MODAL_PERFIL_ACESSO_2"})}
                        </p>
                        <p>{intl.formatMessage({id: "LABELS.MESSAGES.COMMONS.MODAL_PERFIL_ACESSO_3"})}</p>
                    </div>
                    <SdsButton type="button" onClick={callbackContinuar} label="LABELS.COMMONS.CONTINUAR" />
                </div>
            </div>
        </Modal>
    );
};

export default compose(injectIntl)(ModalPerfils);
